module.exports = __webpack_public_path__ + "media/images/shared/suppliers/NRF-8eaa8aff95f89e879903f25e0a86e3b5.jpg";